import _ from "lodash";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import { mntBillUpdate, retryPayment } from "src/api/billingSchedule/billingSchedule-api";
import { useApiOperation } from "src/api/hooks";
import { Modal } from "src/api/public-types";
import { BaseButton, BaseModal, BaseTooltip } from "src/components";
import { objDiff } from "src/pages/contract/hooks/useContractApi";
import { useToast } from "src/recoil/toast/hook";
import { numberToStringWithComma, ViewYmdFormat, YmdFormat } from "src/utils/common-util";
import MakeBillPopup from "../components/MakeBillPopup";
import PaymentStatusView from "../components/PaymentStatusView";
import StorageProcessingModal from "../modal/StorageProcessing/StorageProcessingModal";
const OverdueInfoColumns: any = [
  {
    Header: "청구서 명",
    accessor: "bill.billTitle",
    sticky: "left",
    width: 160,
    Cell: ({ value, row, contractBaseInfo, showBtn, callList: getRounds, selectedScheduleId, buildingId, openToast }: any) => {
      //청구서 수정
      const { executeAsync: updateBill } = useApiOperation(mntBillUpdate);
      const [showUpdateBill, setShowUpdateBill] = useState(false);

      // const [oriBill, setOriBill] = useState<any>();
      const oriBill = row.original.bill;

      const [bill, setBill] = useState(_.cloneDeep(oriBill));
      const [messageModal, setMessageModal] = useState<Modal>({
        isOpen: false,
      });
      const onClosePopup = useCallback(async () => {
        setShowUpdateBill(false);
        await getRounds(selectedScheduleId);
        // setBill(oriBill);
      }, [getRounds, selectedScheduleId]);

      const validateChange = useCallback(
        (detailList?: any) => {
          let diffKeys = [];
          let check = false;
          if (detailList) {
            const original = _.cloneDeep(oriBill);
            const changed = _.cloneDeep(bill);
            const oDetail: any = _.cloneDeep(original.billDetailList);
            const dl = _.cloneDeep(detailList);
            dl.forEach((detail: any) => {
              delete detail.checkTaxAmount;
              delete detail.isAutoTaxUse;
            });
            check = JSON.stringify(oDetail) !== JSON.stringify(dl);

            diffKeys = objDiff(original, changed);

            return (
              diffKeys.filter(
                (str) =>
                  typeof str === "string" &&
                  !str.includes("billDetailList") &&
                  !str.includes("baseAmount") &&
                  !str.includes("totalAmount") &&
                  !str.includes("supplyAmount") &&
                  !str.includes("taxAmount"),
              ).length > 0 || check
            );
          }
        },
        [bill, oriBill],
      );

      const onConfirmBill = async (detailList?: any) => {
        console.log("연체현황 찾았다", detailList);
        const temp = _.cloneDeep(bill);
        let sendData: any = { billId: bill.billId };

        sendData.isConfirmed = !temp.isConfirmed;
        const pass = validateChange(detailList);

        if (pass === undefined || pass === false) {
          const rnt = await updateBill({ scheduleId: bill.scheduleId, body: sendData });
          setBill({ ...temp, ...sendData });
          return rnt;
        } else {
          openToast({ content: "변경 사항이 있습니다. 먼저 저장 후 확정 해주세요 ", isSystemToast: true });
          return;
        }
      };

      /**
       * 저장 버튼 클릭
       */
      const saveBill = useCallback(
        async (detailList: any) => {
          const temp = _.cloneDeep(bill);

          let sendData: any = { billId: oriBill.billId };
          const diffKeys = objDiff(oriBill, bill);
          if (diffKeys.length > 0) {
            for (let i = 0; i < diffKeys.length; i++) {
              const key = diffKeys[i];

              if (key !== "billDetailList") {
                sendData[key] = bill[key];
              }
            }
          }
          if (sendData.billStartTime !== "") {
            sendData.billStartTime = moment(temp.billStartTime).format(YmdFormat.WITH_TIME_ZONE);
          }
          if (sendData.billEndTime !== "") {
            sendData.billEndTime = moment(temp.billEndTime).format(YmdFormat.WITH_TIME_ZONE);
          }
          if (sendData.billIssueDate !== "") {
            sendData.billIssueDate = moment(temp.billIssueDate).format(YmdFormat.WITH_TIME_ZONE);
          }
          if (sendData.billDueDate !== "") {
            sendData.billDueDate = moment(temp.billDueDate).format(YmdFormat.WITH_TIME_ZONE);
          }
          if (sendData.taxInvoiceIssueDate !== null) {
            sendData.taxInvoiceIssueDate = moment(temp.taxInvoiceIssueDate).format(YmdFormat.WITH_TIME_ZONE);
          }

          temp.billDetailList = detailList;
          setBill(temp);
          //저장 기능 처리
          sendData.billDetailList = detailList;
          delete sendData.billPayStatus;
          delete sendData.createdDate;
          delete sendData.modifiedDate;
          delete sendData.modifiedBy;
          delete sendData.createdBy;

          return await updateBill({ scheduleId: bill.scheduleId, body: sendData });
        },
        [oriBill, bill, updateBill],
      );

      useEffect(() => {
        setBill(_.cloneDeep(row.original.bill));
      }, [row.original.bill]);

      return (
        <div>
          <div
            className="text-underline pointer"
            onClick={(e: any) => {
              e.preventDefault();
              setBill(_.cloneDeep(row.original.bill));
              setShowUpdateBill(true);
            }}
          >
            <div className="w-100 text-left cursor-pointer">{value ? <BaseTooltip contents={value} /> : "-"}</div>
          </div>
          {showUpdateBill && (
            <MakeBillPopup
              isChange={showUpdateBill}
              contractDetail={contractBaseInfo}
              showBtn={showBtn}
              bill={_.cloneDeep(bill)}
              setBill={setBill}
              onClose={onClosePopup}
              onConfirm={onConfirmBill}
              onClick={saveBill}
              messageModal={messageModal}
              setMessageModal={setMessageModal}
              getRounds={getRounds}
              allBill={row.original}
              buildingId={bill.buildingId}
              scheduleId={bill.scheduleId}
            />
          )}
          {messageModal.isOpen && (
            <BaseModal
              isOpen={messageModal.isOpen}
              btnRightTitle={"확인"}
              onClick={async () => {
                setMessageModal({ ...messageModal, isOpen: false });
                console.log("어디냐? OverdueInfoColumns");

                // harry 수정
                // await getRounds(bill.scheduleId);
              }}
              title={messageModal.message}
            ></BaseModal>
          )}
        </div>
      );
    },
    Footer: ({ rows }: any) => {
      return <p>합계 : </p>;
    },
  },
  {
    Header: "청구금액 (원)",
    accessor: "bill.baseAmount",
    sticky: "left",
    width: 200,
    Cell: ({ value, row }: any) => {
      if (value) {
        return <p>{numberToStringWithComma(value) + " 원"}</p>;
      } else {
        return <p>-</p>;
      }
    },
    Footer: ({ rows }: any) => {
      let sum = 0;
      rows.forEach((row: any) => {
        sum = sum + Number(row.original.bill?.baseAmount);
      });
      return <p>{numberToStringWithComma(sum) + " 원"}</p>;
    },
  },
  {
    Header: "결제수단",
    accessor: "bill.pgcode",
    sticky: "left",
    width: 120,
    Cell: ({ value }: any) => {
      return (
        <div>
          {value && value === "virtualaccount" && <p>가상계좌</p>}
          {value && value === "creditcard" && <p>신용카드</p>}
          {value && value === "banktransfer" && <p>계좌이체</p>}
        </div>
      );
    },
  },
  {
    Header: "납부시작일시",
    accessor: "bill.billIssueDate",
    width: 120,
    Cell: ({ value }: any) => {
      return <div>{value ? moment(value).format(ViewYmdFormat.YYYY_MM_DD_WEEK_HH_MM_SS) : "-"} </div>;
    },
  },
  {
    Header: "납부종료일시",
    accessor: "bill.billDueDate",
    width: 120,
    Cell: ({ row }: any) => {
      return (
        <div>
          {row.original !== null && row.original.bill !== null && row.original.bill.billDueDate !== undefined
            ? moment(row.original.bill.billDueDate).format(ViewYmdFormat.YYYY_MM_DD_WEEK_HH_MM_SS)
            : "-"}{" "}
        </div>
      );
    },
  },

  {
    Header: "수납확인",
    accessor: "recieve",

    width: 120,
    Cell: ({ value, row, rows, callList, contractBaseInfo, scheduleId, showBtn }: any) => {
      const [isChange, setIsChange] = useState(false);

      const pDatas = useMemo(() => {
        const datas = {
          row,
          rows,
          callList,
          contractBaseInfo,
          scheduleId,
          showBtn,
          isChange,
          setIsChange,
          type: "schedule",
        };
        return datas;
      }, [callList, contractBaseInfo, isChange, row, rows, scheduleId, showBtn]);

      const checkShowPayBtn = useMemo(() => {
        const limit = moment(row.original.bill.billDueDate);
        return moment(limit).isAfter(moment());
      }, [row.original.bill]);

      return (
        <div>
          {/* {moment(today).isSameOrAfter(moment(billDate)) ? ( */}
          <div>
            {showBtn && row.original.bill.billPayStatus !== "PAYMENT_SUCCESS" ? (
              <BaseButton
                title={row.original.receiptBundle.receiptList.length > 0 ? "수정" : "수납처리"}
                className="color-white size-small"
                disabled={
                  Number(row.original.bill.totalAmount) > 0 || row.original.bill.billPayStatus === "PAYMENT_READY" ? false : true || checkShowPayBtn
                }
                onClick={() => setIsChange(true)}
              />
            ) : (
              <BaseButton
                title={"수납확인"}
                className="color-white size-small"
                disabled={
                  row.original.billReceipt !== null ? false : row.original.bill.billPayStatus !== "PAYMENT_SUCCESS" ? false : true || checkShowPayBtn
                }
                onClick={() => setIsChange(true)}
              />
            )}
            {isChange && <StorageProcessingModal processData={pDatas} />}
          </div>
          {/* ) : (
            <p>-</p>
          )} */}
        </div>
      );
    },
  },
  {
    Header: "즉시결제",
    accessor: "instantPayment",
    // sticky: "left",
    width: 120,
    Cell: ({ value, row, rows, showBtn, scheduleId, callList, contractBaseInfo }: any) => {
      const [confirmFlag, setConfirmFlag] = useState(false);
      const [prevStatus, setPrevStatus] = useState<any>("");

      const { openToast } = useToast();

      const { executeAsync: rtp } = useApiOperation(retryPayment);

      const retryPay = useCallback(async () => {
        setConfirmFlag(false);
        const askReturn: any = await rtp({ billId: Number(row.original.bill.billId) }).catch(() => undefined);
        if (askReturn && String(askReturn.data.data.content.result) === "true") {
          await callList();
          openToast({ content: "즉시결제가 정상처리 되었습니다.", isSystemToast: true });
        } else {
          openToast({ content: "즉시결제가 실패하였습니다. 관리자에게 문의해주세요.", isSystemToast: true });
        }
      }, [rtp, row.original.bill.billId, callList, openToast]);

      const checkPrevStatus = useMemo(() => {
        let temp = _.cloneDeep(prevStatus);
        const finded = rows.find((r: any) => Number(r.id) === Number(row.id) - 1);

        if (finded) {
          //console.log(finded.original.bill.billPayStatus);
          temp = finded.original.bill.billPayStatus;
          setPrevStatus(finded.original.bill.billPayStatus);
        }
        return temp;
      }, [prevStatus, row.id, rows]);
      const getBillKey = useMemo(() => {
        let billkey = undefined;
        if (contractBaseInfo && contractBaseInfo.scheduleList) {
          const find = contractBaseInfo.scheduleList.find((obj: any) => obj.supplyType === "RENTAL");

          if (find) {
            return find.billkey;
          }
        }

        return billkey;
      }, [contractBaseInfo]);

      return (
        <>
          {showBtn ? (
            <>
              <BaseButton
                title={"즉시결제"}
                className="color-white size-small"
                disabled={
                  row.original.bill.pgcode !== "creditcard" ||
                  !getBillKey ||
                  // getBillKey === null ||
                  // getBillKey === undefined ||
                  // getBillKey === "" ||
                  row.original.receiptBundle.receiptList.length > 0 ||
                  row.original.bill.billPayStatus === "PAYMENT_SUCCESS" ||
                  moment().isSameOrBefore(moment(row?.original?.bill?.billIssueDate)) ||
                  (row.original.bill.billPayStatus === "PAYMENT_READY" && (checkPrevStatus === "" || checkPrevStatus === "PAYMENT_SUCCESS")
                    ? false
                    : true)
                }
                onClick={() => setConfirmFlag(true)}
              />
              <BaseModal
                title={"즉시 결제하시겠습니까?"}
                isOpen={confirmFlag}
                btnLeftTitle="취소"
                btnRightTitle="확인"
                onClick={() => retryPay()}
                onClose={() => setConfirmFlag(false)}
              ></BaseModal>
            </>
          ) : (
            "-"
          )}
        </>
      );
    },
  },
  {
    Header: "tid",
    accessor: "payment.tid",
    // sticky: "left",
    width: 160,
    Cell: ({ value, row }: any) => {
      let billShowTId = "-";
      const sortedList: any = _.sortBy(row.original.paymentList, ["transactionDate"]).reverse();

      if (sortedList.length > 0) {
        const payment = sortedList[0];

        billShowTId = payment.tid !== "" ? payment.tid : "-";

        if (payment.virtualAccount !== null) {
          billShowTId = payment.virtualAccount.tid;
        }
        if (payment.paymentCancel !== null) {
          billShowTId = payment.paymentCancel.tid;
        }
      }

      return <BaseTooltip contents={billShowTId} />;
    },
  },

  {
    Header: "연체 기간(일)",
    accessor: "receiptBundle.totalOverdueDays",
    // sticky: "left",
    width: 120,
    Cell: ({ value }: any) => {
      return <div>{value ? value + "일" : "-"} </div>;
    },
  },
  {
    Header: "거래일시",
    accessor: "receiptBundle.lastTrDateTime",
    width: 120,
    Cell: ({ value, row }: any) => {
      return value ? moment(value).format(ViewYmdFormat.YYYY_MM_DD_WEEK_HH_MM_SS) : "-";
    },
  },
  {
    Header: "수납 전 금액",
    accessor: "receiptBundle.billTotalAmount",
    // sticky: "left",
    width: 160,
    Cell: ({ row, value }: any) => {
      if (moment().isSameOrAfter(moment(row?.original?.bill?.billIssueDate))) {
        return <div>{numberToStringWithComma(Number(value)) + " 원"}</div>;
      } else {
        return <p>-</p>;
      }
    },
    Footer: ({ rows }: any) => {
      let sum = 0;
      rows.map((row: any) => {
        if (moment().isSameOrAfter(moment(row?.original?.bill?.billIssueDate))) {
          sum = sum + Number(row.original.receiptBundle.billTotalAmount);
        }
      });
      return <p>{numberToStringWithComma(sum) + " 원"}</p>;
    },
  },

  {
    Header: "수납금액",
    accessor: "receiptBundle.receiptTotalAmount",
    // sticky: "right",
    width: 160,
    Cell: ({ row, value }: any) => {
      if (moment().isSameOrAfter(moment(row?.original?.bill?.billIssueDate))) {
        return <div>{numberToStringWithComma(Number(value)) + " 원"}</div>;
      } else {
        return <p>-</p>;
      }
    },
    Footer: ({ rows }: any) => {
      let sum = 0;
      rows.map((row: any) => {
        if (moment().isSameOrAfter(moment(row?.original?.bill?.billIssueDate))) {
          sum = sum + Number(row?.original?.receiptBundle?.receiptTotalAmount);
        }
      });
      return <p>{numberToStringWithComma(sum) + " 원"}</p>;
    },
  },
  {
    Header: "잔액",
    accessor: "receiptBundle.billUnpaidAmount",
    // sticky: "right",
    width: 160,
    Cell: ({ row, value }: any) => {
      if (moment().isSameOrAfter(moment(row?.original?.bill?.billIssueDate))) {
        return <div>{value > 0 ? "-" + numberToStringWithComma(Number(value)) + " 원" : "0 원"} </div>;
      } else {
        return <p>-</p>;
      }
    },
    Footer: ({ rows }: any) => {
      let sum = 0;
      rows.map((row: any) => {
        if (moment().isSameOrAfter(moment(row?.original?.bill?.billIssueDate))) {
          sum = sum + Number(row?.original?.receiptBundle?.billUnpaidAmount);
        }
      });
      return <p>{sum > 0 ? "-" + numberToStringWithComma(sum) + " 원" : "0 원"}</p>;
    },
  },

  {
    Header: "승인",
    accessor: "bill.isConfirmed",
    // sticky: "right",
    width: 90,
    Cell: ({ value, row }: any) => {
      return (
        <div className={`${String(value) === "true" ? "status F" : "status G"}`}>
          <p>{String(value) === "true" ? "확정" : "미확정"}</p>
        </div>
      );
    },
  },
  {
    Header: "청구서 상태",
    accessor: "bill.billPayStatus",
    // sticky: "right",
    width: 120,
    Cell: ({ value, row }: any) => {
      let billIssuDay = moment(row.original.bill.billDueDate).format(ViewYmdFormat.YYYY_MM_DD);
      let today = moment().format(ViewYmdFormat.YYYY_MM_DD);

      if (row.original.bill.billPayStatus === "PAYMENT_READY" && moment(today).isAfter(moment(billIssuDay))) {
        value = "PAYMENT_DELAY";
      }

      return <PaymentStatusView value={value} />;
    },
  },
  {
    Header: "청구서 이메일",
    accessor: "bill.billPayStatus.2",
    width: 120,
    Cell: ({ row, sendingBillEmail }: any) => {
      const sendHistory = row.original.billEtc.chargeEmailSentAt;

      return (
        <div>
          <BaseButton
            title={sendHistory === "" ? "발송" : "재발송"}
            className="color-white size-small"
            disabled={row.original.bill.isConfirmed === false}
            onClick={() => {
              sendingBillEmail({
                billId: row.original.bill.billId,
                billIssueDate: row.original.bill.billIssueDate,
                sendHistory,
              });
            }}
          />
        </div>
      );
    },

    // harry 수정 > deprecated 예정
    // Cell: ({ value, row, showBtn, messageModal, setMessageModal, callList, buildingId, openToast }: any) => {
    //   const sendHistory = row.original.billEtc.chargeEmailSentAt;
    //   const { executeAsync: sendEmail } = useApiOperation(mntBillSendEmail);

    //   const today = moment().toDate();
    //   const [sendFlag, setSendFlag] = useState(false);
    //   const [msg, setMsg] = useState("연체료 청구서가 이메일로 납부시작일에 예약 발송됩니다.");
    //   // const;
    //   const emailAndChangeBillStatus = useCallback(
    //     (params: any) => {
    //       return sendEmail(params);
    //     },
    //     [sendEmail],
    //   );
    //   const checkIssueDate = useCallback(() => {
    //     let flag = false;
    //     if (moment(today).isBefore(moment(row.original.bill.billIssueDate))) {
    //       // console.log("관리비 청구서가 이메일로 납부시작일에 예약 발송됩니다.");
    //       setMsg("연체료 청구서가 이메일로 납부시작일에 예약 발송됩니다.");
    //       flag = false;
    //     } else if (moment(today).isSame(moment(row.original.bill.billIssueDate))) {
    //       // console.log("관리비 청구서가 이메일로 즉시 발송됩니다.");
    //       setMsg("연체료 청구서가 이메일로 즉시 발송됩니다.");
    //       flag = true;
    //     } else {
    //       // console.log("관리비 청구서가 이메일로 즉시 발송됩니다.");
    //       setMsg("연체료 청구서가 이메일로 즉시 발송됩니다.");
    //       flag = true;
    //     }
    //     return flag;
    //   }, [row.original.bill.billIssueDate, today]);

    //   const handleSendMail = useCallback(async () => {
    //     setSendFlag(false);

    //     const flag = checkIssueDate();
    //     const sendParams: any = { billId: row.original.bill.billId, isSendNow: true };
    //     // if (checkIssueDate() === false) {
    //     //   openToast({ content: "납부시작일에 이메일이 발송됩니다.", isSystemToast: true });
    //     // }
    //     const result: any = await emailAndChangeBillStatus(sendParams);
    //     if (result.status >= 200 && result.status < 400) {
    //       setMessageModal({ ...messageModal, message: "발송 요청되었습니다.", isOpen: true });
    //       setSendFlag(false);

    //       await callList(row.original.bill.scheduleId);
    //     }
    //   }, [checkIssueDate, row.original.bill.billId, row.original.bill.scheduleId, emailAndChangeBillStatus, setMessageModal, messageModal, callList]);

    //   //  청구상태가 ‘저장'이고, 승인이 ‘확정’일때만 버튼 활성화
    //   return (
    //     <div>
    //       <BaseButton
    //         title={sendHistory === "" ? "발송" : "재발송"}
    //         className="color-white"
    //         disabled={row.original.bill.isConfirmed === false}
    //         onClick={() => {
    //           checkIssueDate();
    //           setSendFlag(true);
    //         }}
    //       />
    //       {sendFlag && (
    //         <BaseModal
    //           isOpen={sendFlag}
    //           btnLeftTitle={"취소"}
    //           btnRightTitle={"발송"}
    //           onClose={() => {
    //             setSendFlag(false);
    //           }}
    //           onClick={handleSendMail}
    //           title={"발송하시겠습니까?"}
    //         >
    //           <p>{sendHistory !== "" ? "연체료 청구서가 이메일로 재발송됩니다" : msg}</p>
    //         </BaseModal>
    //       )}
    //     </div>
    //   );
    // },
  },
  {
    Header: "최근 청구서 발송일시",
    accessor: "billEtc.chargeEmailSentAt",
    // sticky: "right",
    width: 160,
    Cell: ({ value, row }: any) => {
      return <p>{value !== "" ? moment(value).format(ViewYmdFormat.YYYY_MM_DD_WEEK_HH_MM_SS) : "-"}</p>;
    },
  },
];
export default OverdueInfoColumns;
